function LPStats() {
    return (
        <section className="py-12 carbon-pattern border-y border-white/5">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="text-center md:text-left">
                        <p className="text-slate-400 text-xs uppercase font-bold tracking-widest mb-1">Active Drivers</p>
                        <p className="text-3xl font-bold text-white">12,400<span className="text-primary text-xl tracking-tighter ml-1">+</span></p>
                        <p className="text-accent-cyan text-xs mt-1 font-medium">+12.4% this week</p>
                    </div>

                    <div className="text-center md:text-left">
                        <p className="text-slate-400 text-xs uppercase font-bold tracking-widest mb-1">Laps Tracked</p>
                        <p className="text-3xl font-bold text-white">1.82M</p>
                        <p className="text-accent-cyan text-xs mt-1 font-medium">Global database</p>
                    </div>

                    <div className="text-center md:text-left">
                        <p className="text-slate-400 text-xs uppercase font-bold tracking-widest mb-1">Data Points/Sec</p>
                        <p className="text-3xl font-bold text-white">450k</p>
                        <p className="text-slate-500 text-xs mt-1 font-medium">Real-time throughput</p>
                    </div>

                    <div className="text-center md:text-left">
                        <p className="text-slate-400 text-xs uppercase font-bold tracking-widest mb-1">System Status</p>

                        <div className="flex items-center justify-center md:justify-start gap-2">
                            <span className="size-2 rounded-full bg-accent-cyan animate-pulse"></span>
                            <p className="text-3xl font-bold text-white uppercase italic tracking-tighter">Online</p>
                        </div>

                        <p className="text-slate-500 text-xs mt-1 font-medium">99.9% Uptime</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LPStats;